module.exports = __webpack_public_path__ + "img/flow.5964763c.png";